class CustomExtendedSearch {
  constructor() {
    this.bindEvents();
    this.moveSearchButtonOnMobile();
  }

  bindEvents() {
    if (!!document.querySelector('#nswow-search-field')) {
      document.querySelector("#nswow-search-field").addEventListener("input", (e) => {
        const observer = new MutationObserver((mutations, obs) => {
          const results = document.querySelector(".result-item");
          if (results) {
            this.adjustSearch();
            obs.disconnect();
            return;
          }
        });

        observer.observe(document, {
          childList: true,
          subtree: true
        });
      });
    }
  }

  moveSearchButtonOnMobile() {
    const searchButton = document.getElementById('nswow-search');
    const searchButtonPlaceholder = document.querySelector('.header__mobile-search');
    if (searchButton != null) {
      if (window.innerWidth <= 992) {
        searchButtonPlaceholder.appendChild(searchButton);
      }
    }
  }

  adjustSearch() {
    document.querySelectorAll("#nswow-search-box .result-title a").forEach(result => {
      if(result.getAttribute("href").indexOf("highlight") == -1){
        result.setAttribute("href", result.getAttribute("href") + "?highlight=" + document.querySelector("#nswow-search-field").value);
      }
    });

    if(document.documentElement.clientWidth <= 1240){
      document.querySelectorAll("#nswow-search-box .result-occurrences").forEach(result => {
        result.innerText = "(" + result.innerText.replace(/[^0-9.]/g, '') + ")";
      });
    }
  }
}

export default CustomExtendedSearch;
